<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
        <g fill="none" fill-rule="evenodd">
            <path stroke="#117DFB" stroke-linecap="round" d="M8.872 4.28C8.336 2.278 6.28 1.091 4.28 1.627c-2 .536-3.187 2.592-2.651 4.593.536 2 2.592 3.187 4.593 2.651" transform="rotate(-36 6 5.25)"/>
            <path fill="#117DFB" d="M9.186 5.286l-2.253-.924c-.205-.084-.302-.317-.218-.522.034-.083.095-.153.174-.197l2.522-1.411c.193-.108.437-.04.545.153.04.074.058.158.048.242l-.27 2.335c-.025.219-.223.376-.442.351-.037-.004-.072-.013-.106-.027z" transform="rotate(-36 6 5.25)"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'refresh-icon'
}
</script>

<style scoped>
svg {
    vertical-align: bottom;
    margin-right: 3px;
}
</style>